import { create } from 'zustand';
import {
  ImageSearchErrorType,
  ImageSearchState,
} from 'src/pages/Search/ImageSearch/imageSearch.types';

// TODO [REAL_ENDPOINT]: Con React Query los campos searchState, errorType y searchResults
// serán gestionados por la propia query/mutation (isPending, isError, data).
// Simplificar el store a: selectedFile, selectedDetectedItemIndex, SET_FILE, CLEAR_FILE,
// SET_SELECTED_DETECTED_ITEM y CLEAR. Eliminar SET_SEARCH_STATE, SET_SEARCH_RESULTS,
// SET_ERROR y CLEAR_SEARCH.
interface ImageSearchStoreState {
  selectedFile: File | null;
  searchState: ImageSearchState;
  errorType: ImageSearchErrorType | null;
  selectedDetectedItemIndex: number;
  cacheReferencesBySection: Record<string, string>;
  SET_FILE: (file: File) => void;
  CLEAR_FILE: () => void;
  SET_SEARCH_STATE: (state: ImageSearchState) => void;
  SET_SELECTED_DETECTED_ITEM: (index: number) => void;
  SET_ERROR: (errorType: ImageSearchErrorType) => void;
  CLEAR_SEARCH: () => void;
  SET_CACHE_REFERENCE_BY_SECTION: (section: string, ref: string) => void;
  CLEAR_CACHE_REFERENCES: () => void;
}

export const useImageSearchStore = create<ImageSearchStoreState>((set) => ({
  selectedFile: null,
  searchState: ImageSearchState.IDLE,
  errorType: null,
  selectedDetectedItemIndex: 0,
  cacheReferencesBySection: {},
  SET_FILE: (file) => set({ selectedFile: file }),
  CLEAR_FILE: () => set({ selectedFile: null }),
  SET_SEARCH_STATE: (searchState) =>
    set({
      searchState,
      ...(searchState === ImageSearchState.LOADING
        ? { selectedDetectedItemIndex: 0 }
        : {}),
    }),
  SET_SELECTED_DETECTED_ITEM: (index) => set({ selectedDetectedItemIndex: index }),
  SET_ERROR: (errorType) =>
    set({ errorType, searchState: ImageSearchState.ERROR }),
  CLEAR_SEARCH: () =>
    set({
      searchState: ImageSearchState.IDLE,
      errorType: null,
      selectedDetectedItemIndex: 0,
      cacheReferencesBySection: {},
    }),
  SET_CACHE_REFERENCE_BY_SECTION: (section, ref) =>
    set((state) => ({
      cacheReferencesBySection: { ...state.cacheReferencesBySection, [section]: ref },
    })),
  CLEAR_CACHE_REFERENCES: () => set({ cacheReferencesBySection: {} }),
}));
